module.exports = __webpack_public_path__ + "img/minesweeper.5b5c6911.png";